import client from "./client";

export interface UserNotification {
  id: number;
  text: string;
  created_at: string;
  is_read: boolean;
}

export interface AdminNotification {
  id: number;
  text: string;
  created_at: string;
  read_count: number;
  tg_sent_count: number;
}

export interface NotificationSendResult {
  id: number;
  text: string;
  created_at: string;
  tg_sent: number;
  tg_failed: number;
}

export async function getNotifications(): Promise<UserNotification[]> {
  const res = await client.get<UserNotification[]>("/notifications/");
  return res.data;
}

export async function getUnreadCount(): Promise<number> {
  const res = await client.get<{ count: number }>(
    "/notifications/unread-count",
  );
  return res.data.count;
}

export async function markNotificationRead(id: number): Promise<void> {
  await client.post(`/notifications/${id}/read`);
}

export async function sendNotification(
  text: string,
  sendTg: boolean,
): Promise<NotificationSendResult> {
  const res = await client.post<NotificationSendResult>("/notifications/", {
    text,
    send_tg: sendTg,
  });
  return res.data;
}

export async function getNotificationsAdmin(): Promise<AdminNotification[]> {
  const res = await client.get<AdminNotification[]>("/notifications/admin");
  return res.data;
}
